<!-- Sélecteur d'admission : plusieurs choix possibles et aucune sélection automatique applicable -->
@if (showAdmissionSelector()) {
  <admission-selector
    (admissionSelected)="admissionSelectionChanged($event)"
    (groupOrderQtyChanged)="groupOrderSelectionQuantityChanged($event)"
    [admissions]="admissions()"
    [currentService]="selectedService()"
    />
}

@if (user() && selectedMomentRepas() && allMenus() !== undefined && isOrderContextReady()) {
  <div class="w-full h-full overflow-hidden bg-[#F9F9F9] p-2 flex flex-col">
    <date-selection-header (dateChangedExact)="dateChangedExact($event)" class="border-t border-gris-3" [dayConsultationLimit]="dayConsultationLimit()" [currentDate]="selectedDate()" [daysWithOrders]="daysWithOrders()" [daysWithPartialsOrders]="daysWithPartialsOrders()" [daysWithFullOrders]="daysWithFullOrders()" [mode]="mode()" (dateChangedWithArrows)="dateChangedWithArrows($event)" [daysWithMenus]="daysWithMenus()"/>
    <service-selector-header [mode]="mode()" [servicesWithOrdersOnIt]="servicesWithOrdersOnIt()" [hiddenServices]="hiddenServices()" [services]="services()" [currentService]="selectedService()" (selectServiceChanged)="selectServiceChanged($event)"/>
    @if (mode() === 'day') {
      @if (selectedService(); as service) {
        @if (selectedServiceOrders(); as orders) {
          <!-- Commandes du service sélectionné -->
          <app-order-visualizer [user]="user()" [isAcceptPayment]="isAcceptPayment()" [orders]="orders" [currentService]="service" class="overflow-y-auto"/>
        } @else {
          <!-- Menu du service si pas de commande -->
          <day-menu-display [periodicities]="periodicities()" [admissions]="admissions()" [markedAllergens]="markedAllergens()" [hiddenServices]="hiddenServices()" [uppercaseCourses]="uppercaseCourses()" [boldCourses]="boldCourses()" [dyslexie]="dyslexie()" class="flex-1 block overflow-hidden" mode="day" />
        }
      } @else if (firstOrders().length > 0) {
        <!-- Toutes les commandes du jour s'il n'y a pas de service sélectionné -->
        <app-order-visualizer [user]="user()" [isAcceptPayment]="isAcceptPayment()"
          [orders]="firstOrders()"
          [currentService]="undefined"
          class="overflow-y-auto"/>
      }
    }
  </div>
}

@if (mode() === 'week') {
  <div class="w-full h-full overflow-hidden bg-[#F9F9F9] p-2 flex flex-col">
    <date-selection-header (dateChangedExact)="dateChangedExact($event)" class="border-t border-gris-3" [dayConsultationLimit]="dayConsultationLimit()" [currentDate]="selectedDate()" [daysWithOrders]="daysWithOrders()" [daysWithPartialsOrders]="daysWithPartialsOrders()" [daysWithFullOrders]="daysWithFullOrders()" [mode]="mode()" (dateChangedWithArrows)="dateChangedWithArrows($event)" [daysWithMenus]="daysWithMenus()"/>
    <service-selector-header [mode]="mode()" [hiddenServices]="hiddenServices()" [services]="services()" [currentService]="selectedService()" (selectServiceChanged)="selectServiceChanged($event)"/>
    @if (selectedDate(); as date) {
      <week-menu-display class="flex-1 max-h-full pb-24" [showWeekEnd]="showWeekEnd()" [markedAllergens]="markedAllergens()" [allMenus]="allMenus()" [currentService]="selectedService()" [selectedDate]="date" [uppercaseCourses]="uppercaseCourses()" [boldCourses]="boldCourses()" [dyslexie]="dyslexie()" />
    }
  </div>
}

@if (isLoading()) {
  <div
    [class.inset-0]="selectedMomentRepas()"
    [class.bottom-0]="!selectedMomentRepas()"
    [class.h-24]="!selectedMomentRepas()"
    class="w-full flex items-center justify-center absolute  z-0">
    <div class="flex justify-center items-center space-x-4">
      <span class="relative flex h-6 w-6">
        <span
        class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-500 opacity-75"></span>
        <span class="relative inline-flex rounded-full h-6 w-6 bg-green-500"></span>
      </span>
      <span class="relative flex h-6 w-6">
        <span
        class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-500 opacity-75 [animation-delay:100ms]"></span>
        <span class="relative inline-flex rounded-full h-6 w-6 bg-blue-500"></span>
      </span>
      <span class="relative flex h-6 w-6">
        <span
        class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75 [animation-delay:200ms]"></span>
        <span class="relative inline-flex rounded-full h-6 w-6 bg-red-500"></span>
      </span>
      <span class="relative flex h-6 w-6">
        <span
        class="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-500 opacity-75 [animation-delay:300ms]"></span>
        <span class="relative inline-flex rounded-full h-6 w-6 bg-yellow-500"></span>
      </span>
    </div>
  </div>
}

<!-- Connexion -->
@if (!isLoggedIn() && mode() === 'day') {
  <restaurant-login-form />
}
<!-- Sélecteur de moment repas (masqué s'il n'y a qu'un choix : sélection automatique) -->
@if (showEnterpriseSelector()) {
  <enterprise-selector (enterpriseSelected)="momentRepasChanged($event)"
    [enterprises]="momentsRepas() ?? []"
    class="z-10 bg-white"
    />
}
